export enum EServiceSign {
    GasStation = 1,
}
